import request from './request.js';

// 分页查询客户 API Key
export async function clientApiKeyPage(params = {}) {
  return await request('/clientApiKey/page', 'get', params);
}

// 创建客户 API Key，后端以 RequestParam 接收 clientName
export async function createClientApiKey(params = {}) {
  return await request('/clientApiKey/create', 'post', params);
}
